export const iconFontAwesomeAccessibilityFingerprint = (
	<i className="fa-solid fa-fingerprint"></i>
);
